import { FormikContext } from 'formik'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormik } from '../../../../../common/hooks/formik'
import { PureCheckbox } from '../../../../../common/ui/pure-checkbox/pure-checkbox'
import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { PureSwitcher } from '../../../../../common/ui/pure-switcher/pure-switcher'
import { useFBField } from '../../form-builder.context'
import { FormBuilderConfig } from '../../types/form-builder.types'

type FileConfigProps = { label?: string; multiple: boolean; required?: boolean }

export const FileConfig = ({ label, multiple, required = false }: FileConfigProps) => {
  const { t } = useTranslation()
  const { value: configValue, setValue } = useFBField()
  const formik = useFormik<FileConfigProps>({
    initialValues: {
      label: label || '',
      multiple: multiple || false,
    },
    enableReinitialize: true,
    validationSchema: {},
    onSubmit: (values) => {
      console.log('values', values)
    },
  })
  const options = [
    {
      label: t('common.multiple'),
      value: true,
    },
  ]

  const handleChange = (key: string, value: BaseSyntheticEvent) => {
    setValue({ ...configValue, [key]: value.target.value } as unknown as FormBuilderConfig)
  }

  const handleCheck = (value: boolean[]) => {
    setValue({ ...configValue, multiple: value.includes(true) } as unknown as FormBuilderConfig)
  }

  const handleSwitchChange = (key: string, value: boolean) => {
    setValue({ ...configValue, [key]: value } as unknown as FormBuilderConfig)
  }

  return (
    <FormikContext.Provider value={formik as any}>
      <form onSubmit={formik.handleSubmit}>
        <PureInput
          {...formik.getFieldProps('label')}
          name="label"
          onInput={(e) => handleChange('label', e)}
          placeholder={t('common.name')}
          size="small"
        />
        <PureCheckbox
          {...formik.getFieldProps('multiple')}
          className="mt-2"
          name="multiple"
          onChange={(e) => handleCheck(e as unknown as boolean[])}
          options={options}
          selectAll={false}
        />
        <hr />
        <PureSwitcher
          isChecked={required}
          label={[t('formBuilder.requiredForFill'), t('formBuilder.requiredForFill')]}
          onChange={(value) => handleSwitchChange('required', value)}
          position="left"
        />
      </form>
    </FormikContext.Provider>
  )
}
